import React from 'react';
import '../template-file-css/document-file-template.css';
// import { AddGoalsUsingPatientList } from '../common-controlls/rendergoals-using-client';
// import { AddDxUsingPatientList } from '../common-controlls/renderdiagnosis-using-client';


export const SampleFileTemplate = ({
    itemsRef,
    showErrorFor,
    // selectedPatientList,
    // isEdit,
    // onGoalsDataStateChange,
    // preselctedGoalEdit,
    // isViewDoc,
    // dxPreselectedData,
    // onDxStateChange
}) => {

    return (
        <form id='SampleFileTemplate' className='file-pdf-document'>
            <div className='file-template'> 


                <p className='w-750'>
                    I/We
                    <input type='text' id='txtProviderName_' name='txtProviderName_' className='add-only' />
                    hereby give consent for mental health treatment (which may include services, supports) for the above-named Consumer. Services may include one or more of the following:
                </p>


                <p className='w-750'>
                    I/We
                    <input type='text' id='txtProviderName_' name='txtProviderName_' placeholder='' className='add-only w-200 custom-add-only' />
                    hereby give consent for mental health treatment (which may include services, supports) for the above-named Consumer. Services may include one or more of the following:
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>First Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last Name:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFirstName' name='txtFirstName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastName' name='txtLastName' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Gender:</span></td>
                        <td className='w-375'><span className='eleHeader'>Current Mood:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female &nbsp;
                            <input type='radio' id='rbGender_Other' name='rbGender' className='add-only' value='Other' /> Other
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCurrentMood_1' name='cbCurrentMood_1' className='add-only' value='Anger' /> Anger <br />
                            <input type='checkbox' id='cbCurrentMood_2' name='cbCurrentMood_2' className='add-only' value='Happy' /> Happy <br />
                            <input type='checkbox' id='cbCurrentMood_3' name='cbCurrentMood_3' className='add-only' value='Confused' /> Confused
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Time of Birth:</span></td>
                        <td className='w-375'><span className='eleHeader'>Date of Birth:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='time' id='txtTimeBirth' name='txtTimeBirth' className='add-only' />
                        </td>
                        <td className='w-375'><input type='date' id='txtDateBirth' name='txtDateBirth' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Favorite Fruit:</span>

                    <select id='ddlFavoriteFruit' name='ddlFavoriteFruit' className='add-only'>
                        <option value='NA'></option>
                        <option value='Mango'> Mango</option>
                        <option value='Grape'> Grape</option>
                        <option value='Orange'> Orange</option>
                        <option value='Apple'> Apple</option>
                    </select>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Medical History:</span>
                    <span className='small'>(add all the details from last 2 years.)</span>
                    <textarea id='txtMedicalHistory' name='txtMedicalHistory' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Appropriately Licensed Practitioner & Credentials </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


                {/* Goal and Dx section */}




                {/* <div>
                    <AddGoalsUsingPatientList
                        isEdit={isEdit}
                        preselctedGoalEdit={preselctedGoalEdit}
                        selectedPatientList={selectedPatientList}
                        onDataStateChange={onGoalsDataStateChange}
                        isViewDoc={isViewDoc}
                    />
                </div>

                <div>
                    <AddDxUsingPatientList
                        isEdit={isEdit}
                        preselctedDxListEdit={dxPreselectedData}
                        selectedPatientList={selectedPatientList}
                        onDataStateChange={onDxStateChange}
                        isViewDoc={isViewDoc}
                    ></AddDxUsingPatientList>
                </div> */}



            </div>
        </form>

    )
}   